import * as atcClassificationsActions from './atcClassifications'
import * as authActions from './auth'
import * as userActions from './user'
import * as specialitiesActions from './specialities'
import * as laboratoriesActions from './laboratories'
import * as severitiesActions from './severities'
import * as medicationsActions from './medications'
import * as medicationsClassificationActions from './medicationsClassification'
import * as messageActions from './message'
import * as authorsActions from './authors'
import * as contentActions from './content'
import * as keywordsActions from './keywords'
import * as confirmActions from './confirm'
import * as searchTableActions from './searchTable'
import * as ratingsActions from './ratings'
import * as referencesActions from './references'
import * as preRegistrationsActions from './preRegistrations'
import * as profilesActions from './profiles'
import * as medicationsTypesActions from './medicationsTypes'
import * as dcbNamesActions from './namesDcb'
import * as probabilitiesActions from './probabilities'
import * as interactionsTypeActions from './interactionsType'
import * as interactionsActions from './interactions'
import * as imagesTimeActions from './imagesTimes'
import * as readingTimeActions from './readingTime'
import * as cidsActions from './cids'
import * as bookVectorizationActions from './bookVectorization'
import * as contentVectorizationActions from './contentVectorization'

export {
  atcClassificationsActions,
  authActions,
  userActions,
  laboratoriesActions,
  medicationsActions,
  severitiesActions,
  medicationsClassificationActions,
  messageActions,
  confirmActions,
  specialitiesActions,
  authorsActions,
  keywordsActions,
  contentActions,
  searchTableActions,
  ratingsActions,
  preRegistrationsActions,
  profilesActions,
  medicationsTypesActions,
  dcbNamesActions,
  referencesActions,
  probabilitiesActions,
  interactionsTypeActions,
  interactionsActions,
  imagesTimeActions,
  readingTimeActions,
  cidsActions,
  bookVectorizationActions,
  contentVectorizationActions,
}



// WEBPACK FOOTER //
// ./src/actions/index.js